import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const NegativeFillDiamond = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M9.37409 2.15508C9.00967 1.79066 8.51541 1.58594 8.00005 1.58594C7.48469 1.58594 6.99043 1.79066 6.62601 2.15508L1.65484 7.12626C1.29042 7.49067 1.08569 7.98493 1.08569 8.50029C1.08569 9.01566 1.29042 9.50991 1.65484 9.87433L6.62601 14.8455C6.99043 15.2099 7.48469 15.4147 8.00005 15.4147C8.51541 15.4147 9.00967 15.2099 9.37409 14.8455L14.3453 9.87433C14.7097 9.50991 14.9144 9.01566 14.9144 8.50029C14.9144 7.98493 14.7097 7.49067 14.3453 7.12626L9.37409 2.15508ZM6.05811 6.55837C6.30219 6.3143 6.69791 6.3143 6.94199 6.55837L8.00005 7.61643L9.05811 6.55837C9.30219 6.3143 9.69791 6.3143 9.94199 6.55837C10.1861 6.80245 10.1861 7.19818 9.94199 7.44226L8.88393 8.50032L9.94199 9.55837C10.1861 9.80245 10.1861 10.1982 9.94199 10.4423C9.69791 10.6863 9.30219 10.6863 9.05811 10.4423L8.00005 9.3842L6.94199 10.4423C6.69791 10.6863 6.30219 10.6863 6.05811 10.4423C5.81403 10.1982 5.81403 9.80245 6.05811 9.55837L7.11617 8.50032L6.05811 7.44226C5.81403 7.19818 5.81403 6.80245 6.05811 6.55837Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
